import { eventChannel } from 'redux-saga';

/**
 * Create Event listeners for when the pointer is moving
 * @param {Object} controller - contains methods to manipulate the model, viewer and segmentation tree.
 * @returns {Object} EventListener state is changed according to the event
 */
const pointerMove = (controller) =>
  eventChannel((emit) => {
    controller.viewer.viewport.container.addEventListener('pointermove', emit);
    return () =>
      controller.viewer.viewport.container.removeEventListener(
        'pointermove',
        emit,
      );
  });

/**
 * Create Event listeners for when the pointer is down
 * @param {Object} controller - contains methods to manipulate the model, viewer and segmentation tree.
 * @returns {Object} EventListener state is changed according to the event
 */
const pointerDown = (controller) =>
  eventChannel((emit) => {
    controller.viewer.viewport.container.addEventListener('pointerdown', emit);
    return () =>
      controller.viewer.viewport.container.removeEventListener(
        'pointerdown',
        emit,
      );
  });

/**
 * Create Event listeners for when the pointer is up
 * @param {Object} controller - contains methods to manipulate the model, viewer and segmentation tree.
 * @returns {Object} EventListener state is changed according to the event
 */
const pointerUp = (controller) =>
  eventChannel((emit) => {
    controller.viewer.viewport.container.addEventListener('pointerup', emit);
    return () =>
      controller.viewer.viewport.container.removeEventListener(
        'pointerup',
        emit,
      );
  });

export default {
  pointerMove,
  pointerDown,
  pointerUp,
};
